import { createFileRoute, Outlet, redirect } from '@tanstack/react-router';
import { toast } from 'sonner';

import { useAuthStore } from '@/features/auth/model/store';
import { hasAuthToken } from '@/shared/lib/auth';

export const Route = createFileRoute('/admin')({
  component: () => <Outlet />,

  beforeLoad: ({ location }) => {
    const { member } = useAuthStore.getState();

    if (!hasAuthToken()) {
      sessionStorage.setItem('redirectAfterLogin', location.href);
      toast('알림', {
        description: '로그인이 필요한 서비스입니다.',
      });
      throw redirect({ to: '/sign-in' });
    }

    if (!member?.roles?.includes('ADMIN')) {
      toast.error('관리자 권한이 필요합니다.');
      throw redirect({ to: '/' });
    }
  },
});
